export function checkFavourites(){
  let favourites = localStorage.hasOwnProperty("latino_favourites") ? JSON.parse(localStorage.getItem("latino_favourites")) : [];
  if(favourites.length) {
    favourites.forEach(function(favourite){ $('a[data-fav="' + favourite + '"]').addClass('active') })
    $('i.favourites-count').text(favourites.length)
  }
}

export function favouriteButtons() {
  $('body').on('click', 'a[data-fav]', function(e){
    e.preventDefault();
    const $button = $(this)
    const favourite = $button.attr('data-fav')
    let favourites = localStorage.hasOwnProperty("latino_favourites") ? JSON.parse(localStorage.getItem("latino_favourites")) : [];
    if(favourites.includes(favourite)) {
      favourites = favourites.filter(function(item) { return item !== favourite })
      $('a[data-fav="' + favourite + '"]').removeClass('active')
      $('.query-item[data-fav="' + favourite + '"]').remove()
      if(!favourites.length) { $('.favourites__content').html(''); }
    } else {
      favourites.unshift(favourite)
      $('a[data-fav="' + favourite + '"]').addClass('active')
      $('.header__favourites .favourites__content').html('')
    }
    localStorage.setItem("latino_favourites", JSON.stringify(favourites));
    $('i.favourites-count').text(favourites.length ? favourites.length : '')
  })
}

export function favouritesPanel() {
  $('.toggle-favourites').click(function(e){
    e.preventDefault();
    if(!$('body').hasClass('open-favourites')) {
      $('body[class*="open-"]').removeClass(function (index, css) { return (css.match (/(^|\s)open-\S+/g) || []).join(' '); });
      loadFavourites()
    }
    $('body').toggleClass('open-favourites')
  })
  $('.header__favourites').click(function(e){
    if(e.target == e.currentTarget) {
      e.preventDefault();
      $('body').removeClass('open-favourites')
    }
  })
}


export function loadFavourites() {
  let favourites = localStorage.hasOwnProperty("latino_favourites") ? JSON.parse(localStorage.getItem("latino_favourites")) : [];
  if(favourites.length && $('.header__favourites .favourites__content').is(':empty')) {
    $('.header__favourites .favourites__content').addClass('loading')
    var data = { 'action': 'ajax_posts', 'favourites': favourites };
    jQuery.post(window.latino.ajaxurl, data, function(response) {
      setTimeout(function(){
        $('.header__favourites .favourites__content').removeClass('loading').html(response)
      }, 500)
    });
  }
}
